import React,{Component} from "react";
import appinfo from "../../clientsJSON";
import "../home/index.css";
import {
    Menu,
    Footer,
    Team
} from "../../component";

class Teams extends Component {
    render(){
        document.title = "Team | " + appinfo.name;
       
        return (
            <div>
                <Menu/>
                <div className="mp-container">
                    
                 <Team/>
                </div>
                <Footer/>
            </div>
        )
    }    
}
export default Teams;